var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { navigateAction } from 'fluxible-router';
import * as React from 'react';
import performSearchAction from '../../../action/performSearch';
import SearchService from '../../../services/SearchService';
import { SearchResultState } from '../../../stores/SearchStore';
import { useFluxible } from '../../hooks/useFluxible';
import { Pagination } from '../../Pagination/Pagination.old';
import { Spinner } from '../../Spinner';
import { GlossaryTermWidget } from './GlossaryTermWidget/GlossaryTermWidget.old';
import SearchResult from './SearchResult';
import styles from './styles.module.styl';
export var SearchPage = function (_a) {
    var _b, _c, _d;
    var terms = _a.terms, result = _a.result, query = _a.query, page = _a.page;
    var context = useFluxible();
    React.useEffect(function () {
        if (query) {
            context.executeAction(performSearchAction, { query: query, page: page });
        }
    }, []);
    var handleClick = function (_a) {
        var e = _a.e, id = _a.id, url = _a.url, isDocument = _a.isDocument;
        SearchService.recordClickthrough(query, id, url);
        if (e.target.href) {
            e.preventDefault();
            if (isDocument) {
                context.executeAction(navigateAction, { url: new URL(e.target.href).pathname });
            }
            else {
                window.location.assign(e.target.href);
            }
        }
    };
    var handlePageChange = function (page) {
        context.executeAction(performSearchAction, { query: query, page: page });
    };
    var renderResultContent = function () {
        var _a, _b, _c, _d;
        if (!result) {
            return React.createElement("p", null, "Please enter a query to search our documentation.");
        }
        switch (result.state) {
            case SearchResultState.LOADING:
                return React.createElement(Spinner, null);
            case SearchResultState.LOADED:
                if (((_a = result === null || result === void 0 ? void 0 : result.response) === null || _a === void 0 ? void 0 : _a.record_count) === 0) {
                    return React.createElement("p", null, "No results found. Would you like to try another search term?");
                }
                // TODO: Show result count, pagination, etc.
                return (_d = (_c = (_b = result === null || result === void 0 ? void 0 : result.response) === null || _b === void 0 ? void 0 : _b.records) === null || _c === void 0 ? void 0 : _c.page) === null || _d === void 0 ? void 0 : _d.map(function (item) {
                    var _a;
                    return (React.createElement(SearchResult, { key: item === null || item === void 0 ? void 0 : item.id, id: item === null || item === void 0 ? void 0 : item.id, title: item === null || item === void 0 ? void 0 : item.title, url: item === null || item === void 0 ? void 0 : item.url, content: (_a = item === null || item === void 0 ? void 0 : item.highlight) === null || _a === void 0 ? void 0 : _a.body, handleClick: handleClick }));
                });
            case SearchResultState.ERROR:
                return React.createElement("p", null, "There was an error loading the search result. Please try again.");
            default:
                throw new Error("Unknown search state ".concat(result === null || result === void 0 ? void 0 : result.state));
        }
    };
    var title = result ? 'Search Results' : 'Search';
    var matchedTerm = (result === null || result === void 0 ? void 0 : result.state) === SearchResultState.LOADED &&
        (terms === null || terms === void 0 ? void 0 : terms.find(function (term) {
            if (term.title.toLowerCase() === (query === null || query === void 0 ? void 0 : query.toLowerCase())) {
                return true;
            }
            if (Array.isArray(term === null || term === void 0 ? void 0 : term.alias) && (term === null || term === void 0 ? void 0 : term.alias.find(function (a) { return a.toLowerCase() === (query === null || query === void 0 ? void 0 : query.toLowerCase()); }))) {
                return true;
            }
            return false;
        }));
    return (React.createElement("div", { className: "document" },
        React.createElement("div", { className: "".concat(styles.searchContainer, " container search-results") },
            React.createElement("h1", { className: styles.title }, title),
            matchedTerm ? React.createElement(GlossaryTermWidget, __assign({}, matchedTerm)) : React.createElement("div", { style: { display: 'none' } }),
            React.createElement("div", { className: styles.searchResults }, renderResultContent()),
            (result === null || result === void 0 ? void 0 : result.state) === SearchResultState.LOADED && (React.createElement(Pagination, { activePage: page, pageCount: (_d = (_c = (_b = result === null || result === void 0 ? void 0 : result.response) === null || _b === void 0 ? void 0 : _b.info) === null || _c === void 0 ? void 0 : _c.page) === null || _d === void 0 ? void 0 : _d.num_pages, onChange: handlePageChange })))));
};
